import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import TooltipModal from 'Components/TooltipModal'

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const InputWrapper = styled.div`
  position: relative;
  display: inline-block;
`

const InputField = styled.input`
  height: 32px;
  width: 48px;
  border: ${props => (props.error ? '1px solid red' : '1px solid #e2e2fc')};
  border-radius: 6px;
  text-align: center;
  -moz-appearance: textfield;

  &::placeholder {
    color: #b0b0b0;
    opacity: 0.6;
  }
  &:-ms-input-placeholder {
    color: #b0b0b0;
    opacity: 0.6;
  }
  &::-ms-input-placeholder {
    color: #b0b0b0;
    opacity: 0.6;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

const Label = styled.div`
  font-family: 'Proxima Nova', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  color: #707087;
  margin-right: 6px;
`

const Value = styled.div`
  font-family: 'Proxima Nova', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #707087;
`

const Prefix = styled.div`
  position: absolute;
  right: 8px;
  top: 54%;
  transform: translateY(-50%);
  color: #707087;
  font-size: 14px;
  pointer-events: none;
`

const MinutesInput = ({
  value,
  label,
  onChange = () => {},
  max = null,
  min = 0,
  viewOnly = false,
  prefix = null,
  width = '48px',
  type = null,
  tooltip = null,
  tooltipPlacement = 'bottom-start',
  placeholder,
  error = null,
}) => {
  const [displayValue, setDisplayValue] = useState(String(value))

  useEffect(() => {
    setDisplayValue(String(value))
  }, [value])

  const handleChange = e => {
    let val = e.target.value.replace(/\D/g, '')

    if (val.length > 2) {
      val = val.slice(-2)
    }

    if (val.length === 1) {
      setDisplayValue(val)
    } else if (val.length === 2) {
      let num = parseInt(val, 10)

      if (num > 59) num = 59

      const formatted = num.toString().padStart(2, '0')
      setDisplayValue(formatted)
      onChange(formatted)
    } else {
      // empty
      setDisplayValue('')
      onChange('')
    }
  }

  const handleBlur = () => {
    if (displayValue.length === 1) {
      const padded = displayValue.padStart(2, '0')
      setDisplayValue(padded)
      onChange(padded)
    }
  }

  return (
    <Container>
      {tooltip ? (
        <TooltipModal placement={tooltipPlacement} content={tooltip} />
      ) : null}
      {label ? <Label>{label}</Label> : null}
      {viewOnly ? (
        <Value>
          {value}
          {prefix && ` ${prefix}`}
        </Value>
      ) : (
        <InputWrapper>
          <InputField
            type="text"
            value={displayValue}
            min={min}
            max={max}
            onChange={handleChange}
            onBlur={handleBlur}
            style={prefix ? { width, paddingRight: '20px' } : { width }}
            placeholder={placeholder}
            error={error}
          />
          {prefix && <Prefix>{prefix}</Prefix>}
        </InputWrapper>
      )}
    </Container>
  )
}

export default MinutesInput
